/**
 * Whether texting can be switched on for the SID that has been typed.
 *
 * The integration identifies the organization's Twilio subaccount by this value
 * and cannot look anything up without it, so an empty field leaves the switch out
 * of reach.
 */
export const canEnableTwilio = (accountSid: string): boolean => accountSid.trim() !== ''

/**
 * Whether texting has a subaccount to reach once the form is saved.
 *
 * An emptied field is not the same as no subaccount: the update sends null for a blank
 * one and the organization keeps the SID it already had, so a field cleared to be
 * retyped still identifies a subaccount. Reading the field alone would treat an edit in
 * progress as an outage and take texting — and everything behind it — off with it.
 */
export const hasUsableAccountSid = (
  accountSid: string,
  storedAccountSid: string | null
): boolean => canEnableTwilio(accountSid) || canEnableTwilio(storedAccountSid ?? '')
